import React, { Component } from "react";
import { connect } from "dva";
import { Badge } from "antd";
import router from "umi/router";
import { stringify } from "qs";
import ListPage from "@/components/ListPage";
import OperateDropdown from "@/components/OperateDropdown";

const { ListTable } = ListPage;
const statusMap = {
  0: "error",
  1: "success"
};
@connect(({ evaluation }) => ({
  reportTargetList: evaluation.reportTargetList,
  pageInfo: evaluation.pageInfo,
  spinProps: evaluation.spinProps
}))
class TargetTable extends Component {
  constructor(props) {
    super(props);

    const columns = [
      {
        title: "填报单位名称",
        dataIndex: "name"
      },
      {
        title: "状态",
        render: record => {
          const { statusName, status } = record;
          const statusCls = statusMap[status];
          return <Badge status={statusCls} text={statusName} />;
        }
      },
      {
        title: "操作",
        render: record => {
          const data = [
            {
              text: (
                <a onClick={event => this.handleJump({ record, event })}>
                  {record.status === 1 ? "重新评估" : "评估"}
                </a>
              )
            }
          ];
          return <OperateDropdown data={data} />;
        }
      }
    ];

    this.state = {
      columns
    };
  }

  componentDidMount() {
    this.getDetailList();
  }

  componentDidUpdate(prevProps) {
    const { projectId, normIndex } = this.props;
    if (
      prevProps.projectId !== projectId ||
      prevProps.normIndex !== normIndex
    ) {
      this.getDetailList();
    }
  }

  // 分页改变
  handlePaginationChange = (page, pageSize) => {
    const pageInfo = { page, pageSize };
    this.getDetailList(pageInfo);
  };

  getDetailList = pageInfo => {
    const { projectId, normIndex } = this.props;
    const { dispatch } = this.props;
    dispatch({
      type: "evaluation/fetchReportList",
      payload: {
        projectId,
        indexId: normIndex,
        page: 1,
        pageSize: 10,
        ...pageInfo
      }
    });
  };

  handleJump = ({ record, event }) => {
    if (event) {
      event.stopPropagation();
    }
    const { name, groupId, orgId } = record;
    const { projectId, normIndex, onRemember, nowPath } = this.props;
    onRemember(true, () => {
      router.push(
        `${nowPath}/evaluateTree?${stringify({
          currentProjectId: projectId,
          currentGroupId: groupId,
          currentOrgId: orgId,
          indexId: normIndex,
          orgName: name
        })}`
      );
    });
  };

  render() {
    const { columns } = this.state;
    const { reportTargetList, spinProps, pageInfo } = this.props;

    const pageProps = {
      spinProps
    };

    const tableProps = {
      columns,
      rowKey: "id",
      list: reportTargetList,
      pageInfo,
      onPageChange: this.handlePaginationChange
    };

    return (
      <ListPage {...pageProps}>
        <ListTable {...tableProps} />
      </ListPage>
    );
  }
}

export default TargetTable;
